import React, { useEffect, useState } from "react";
import { Drawer } from "@mui/material";
import GrouMemberList from "./GroupMemberDeatils";
import { leftOverlayDrawerSx } from "../../../assets/commonFunction";
const GroupMemberDrawer = ({ isGroupmembermenu, handleCloseMemberDrawer }) => {
  // The member list renders only while the drawer is open (until it has slid
  // out): a persistent drawer keeps its content mounted, and a big group's
  // list is ~26,000 elements, re-rendered with the chat screen.
  const [showList, setShowList] = useState(isGroupmembermenu);
  useEffect(() => {
    if (isGroupmembermenu) setShowList(true);
  }, [isGroupmembermenu]);

  return (
    <React.Fragment>
      <Drawer
        sx={{ zIndex: 1202, ...leftOverlayDrawerSx }}
        open={isGroupmembermenu}
        anchor={"left"}
        variant="persistent"
        SlideProps={{ onExited: () => setShowList(false) }}
      >
        {showList && <GrouMemberList handleCloseMemberDrawer={handleCloseMemberDrawer} />}
      </Drawer>
    </React.Fragment>
  );
};

export default GroupMemberDrawer;
